
import { ProductConstants } from "../_constants";
import * as commonAction from "./commonAction";
import { userService, commonService } from "../_services";
import { alertActions } from "./";
import { history } from "../_helpers";
import { apiConstants } from "../_constants/api.constants";

export const productActions = {
    saveProduct,
    getProducts,
    getSingleProduct,
    updateProduct,
    deleteProducts,
    getAttributes,
    copyProduct
};

function saveProduct(apiName, productData) {
  return dispatch => {
    dispatch(commonAction.request(ProductConstants.PRODUCT_ADDED_REQUEST, productData ));
    commonService.withToken(apiName, productData).then(
      getProduct => {        
        dispatch(commonAction.success(ProductConstants.PRODUCT_ADDED_SUCCESS, getProduct));
      },
      error => {
        dispatch(
          commonAction.failure(ProductConstants.PRODUCT_ADDED_FAILURE, error)
        );        
      }
      );
  };
}
 
function getProducts(apiName, reqObj) {
  return dispatch => {
    dispatch(commonAction.request(ProductConstants.PRODUCT_GET_REQUEST, reqObj ));
    commonService.withToken(apiName, reqObj).then(
      getProduct => {        
        dispatch(commonAction.success(ProductConstants.PRODUCT_GET_SUCCESS, getProduct));
      },
      error => {
        dispatch(
          commonAction.failure(ProductConstants.PRODUCT_GET_FAILURE, error)
        );        
      }
      );
  };
}

function getSingleProduct(apiName, reqObj) {
  return dispatch => {
    dispatch(commonAction.request(ProductConstants.SINGLE_PRODUCT_GET_REQUEST, reqObj ));
    commonService.withToken(apiName, reqObj).then(
      getProduct => {        
        dispatch(commonAction.success(ProductConstants.SINGLE_PRODUCT_GET_SUCCESS, getProduct));
      },
      error => {
        dispatch(
          commonAction.failure(ProductConstants.SINGLE_PRODUCT_GET_FAILURE, error)
        );        
      }
      );
  };
}

function updateProduct(apiName, reqObj) {
  return dispatch => {
    dispatch(commonAction.request(ProductConstants.SINGLE_PRODUCT_UPDATE_REQUEST, reqObj ));
    commonService.withToken(apiName, reqObj).then(
      getProduct => {
        dispatch(commonAction.success(ProductConstants.SINGLE_PRODUCT_UPDATE_SUCCESS, getProduct));
      },
      error => {
        dispatch(
          commonAction.failure(ProductConstants.SINGLE_PRODUCT_UPDATE_FAILURE, error)
        );
      }
      );
  };
}

function deleteProducts(apiName, reqObj) {
  return dispatch => {
    dispatch(commonAction.request(ProductConstants.DELETE_MY_PRODUCT_REQUEST, reqObj ));
    commonService.withToken(apiName, reqObj).then(
      deletedResponse => {
        dispatch(commonAction.success(ProductConstants.DELETE_MY_PRODUCT_SUCCESS, deletedResponse));
      },
      error => {
        dispatch(
          commonAction.failure(ProductConstants.DELETE_MY_PRODUCT_FAILURE, error)
        );
      }
      );
  };
}

function getAttributes(apiName, reqObj){
  return dispatch => {
    dispatch(commonAction.request(ProductConstants.GET_PRODUCT_ATTRIBUTE_REQUEST, reqObj ));
    commonService.withToken(apiName, reqObj).then(
      deletedResponse => {
        dispatch(commonAction.success(ProductConstants.GET_PRODUCT_ATTRIBUTE_SUCCESS, deletedResponse));
      },
      error => {
        dispatch(
          commonAction.failure(ProductConstants.GET_PRODUCT_ATTRIBUTE_FAILURE, error)
        );
      }
      );
  };
}

/* Copy Product - Need to copy existing product */
function copyProduct(apiName, productId) {
  return dispatch => {
    dispatch(commonAction.request(ProductConstants.PRODUCT_GET_REQUEST, productId ));
    commonService.withToken(apiName, productId).then(
      copyProduct => {        
        dispatch(commonAction.success(ProductConstants.PRODUCT_GET_SUCCESS, copyProduct));
      },
      error => {
        dispatch(
          commonAction.failure(ProductConstants.PRODUCT_GET_FAILURE, error)
        );        
      }
      );
  };
}